// extracted by mini-css-extract-plugin
export var demoButton = "desktopNavbarItems-module--demoButton--33963";
export var item = "desktopNavbarItems-module--item--dd10b";
export var link = "desktopNavbarItems-module--link--1e020";
export var navbarDesktop = "desktopNavbarItems-module--navbarDesktop--7e678";
export var navbarItems = "desktopNavbarItems-module--navbarItems--c758b";
export var pricingButton = "desktopNavbarItems-module--pricingButton--15063";
export var trialButton = "desktopNavbarItems-module--trialButton--0d174";